import {where} from "firebase/firestore";
import {sumarPropiedadColeccionWheres} from "../../Servicios/BD/Contadores/sumarPropiedadColeccionWheres";

export const obtenerTotalRendimientos = async ({idBolsillo}) => {

    let wheres =
        [
            where('idBolsillo', '==', idBolsillo),
            where('estado', '==', 'Aceptado'),
            where('tipo', '==', 'Rendimiento'),
        ]

    let dox = await sumarPropiedadColeccionWheres({coleccion: 'movimientos', wheres: wheres, propiedad: 'valor'})

    if (dox.res) {
        return dox.data
    } else {
        return 0
    }
}